import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - ATW presents a Website Builder` : 'ATW presents a Visual Builder',
  setup({ el, App, props, plugin }) {
    const hasPermission = (permissions, permission) => {

   


      // Improved permission check logic:
      if (!props.initialPage.props.auth) {
        return false; // No permissions prop, deny access
      }

      if(!permission) {
         permission = permissions;
         permissions = props.initialPage.props.permissions  
      }

      //console.log(permissions)
      return permissions.includes(permission);


      
    };

    const hasPermissionUserCheck = (permission, useruuid) => {

      // Improved permission check logic:
      if (!props.initialPage.props.auth) {
        return false; // No permissions prop, deny access
      }

         const permissions = props.initialPage.props.permissions  
      
        var userid = null;
        if(useruuid === "0") {
          userid = "666"
        }

        userid = useruuid + ''

         if(props.initialPage.props.auth.user.account_id === userid) {
          return true
         } else {
          return permissions.includes(permission)
         }
  
    };

  

    const myApp = createApp({
      render: () => h(App, props),
      comments: false, // Disable comments
      // Make the hasPermission function globally accessible
      provide: {
        hasPermission,
        hasPermissionUserCheck,
      },
    })
    .use(plugin);

    myApp.config.globalProperties.hasPermission = hasPermission;
    myApp.config.globalProperties.hasPermissionUserCheck = hasPermissionUserCheck;
    myApp.mount(el);
    return myApp;
  },
});


// import { createApp, h } from 'vue';
// import { createInertiaApp } from '@inertiajs/vue3';

// createInertiaApp({
//   resolve: name => require(`./Pages/${name}`),
//   title: title => title ? `${title} - DVL Portal` : 'DVL Portal',
//   setup({ el, App, props, plugin }) {
//     createApp({ 
//       render: () => h(App, props),
//       comments: false // Disable <!-- v-if --> comments
//     })
//     .use(plugin)
//     .mount(el);
//   },
// });
